// import { allTeams } from '@timhortonsdigital/tims-hockey-logos';

// const teamLogos = Object.keys(allTeams).reduce((acc, curr) => {
//   const team = allTeams[curr];

//   return {
//     ...acc,
//     [curr]: team.filename
//   };
// }, {});

const allImages = {
  // Logos
  hockeyChallengeLogo: '2025_hockey-challenge-logo.png',
  hockeyChallengeLogoFr: '2025_hockey-challenge-logo-fr.png',

  // Backgrounds
  bannerBgDefault: 'banner-bg.png',
  bannerBgBlack: 'banner-bg-black.png',
  redTexture: 'red-texture.jpg',
  iceTexture: 'ice-texture.jpg',

  // Banners
  bannerPlayerGraphic: 'play-banner-graphic.png',
  bannerPlayerGraphicFr: 'play-banner-graphic-fr.png',
  bannerTicketRed: 'prize-ballot-entry.png',
  bannerTicketRedFr: 'prize-ballot-entry.png',
  bannerTicketYellow: 'ballot-entry-self-directed.png',
  bannerTicketYellowFr: 'ballot-entry-self-directed.png',
  prizeInstantCoffee: 'instant-prize-coffee.png',
  prizeInstantCoffeeFr: 'instant-prize-coffee-fr.png',
  bannerAutoPicks: 'scout-picks-background.png',

  // Icons
  iconTicket: 'ticket-empty.svg',
  iconTicketWhite: 'ticket.svg',
  iconTicketRed: 'ticket-red.svg',
  iconTicketYellow: 'ticket-yellow.svg',
  iconCoffeeWithRedTicket: 'instant-prize-coffee-red.svg',
  iconCoffeeWithYellowTicket: 'instant-prize-coffee-yellow.svg',
  iconLock: 'lock.svg',
  iconLockNew: 'lock_new.svg',
  iconNewLock: 'new_lock.svg',
  iconFlame: 'icon_flame.svg',
  sticks: 'sticks.svg',
  errorTriangle: 'error-triangle.svg',
  chevronUp: 'chevron_up.svg',
  chevronDown: 'chevron_down.svg',

  // Graphics
  loadingSticks: 'loading-sticks.png',
  hockeySticks: '2025_sticks.png',
  hockeySticksSmall: '2025_small_sticks.svg',

  // Logos
  collectToWinLogo: 'collect-to-win-logo.png',
  collectToWinLogoFr: 'collect-to-win-logo-fr.png',
  collectToWinLogoSmall: 'collect-to-win-logo-small.png',
  collectToWinLogoSmallFr: 'collect-to-win-logo-small-fr.png',
  collectToWinLogoWithTicket: 'collect-to-win-logo-ticket.png',
  collectToWinLogoWithTicketFr: 'collect-to-win-logo-ticket-fr.png',

  // How To
  howToPick: 'Step1.png',
  howToSubmit: 'Step2.png',
  howToWin: 'howto-step3.png',

  howToScan: 'howto-scan.png',
  howToScanFr: 'howto-scan-fr.png',
  howToEarn: 'howto-earn.png',
  howToEarnFr: 'howto-earn-fr.png',
  howToUnwrap: 'howto-unwrap.png',
  howToUnwrapFr: 'howto-unwrap-fr.png',

  // Prizes
  freeCoffeeInstant: 'free-coffee-instant.png',
  freeCoffeeInstantFr: 'free-coffee-instant.png',
  freeCoffeeYear: 'free-coffee-year.png',
  freeCoffeeYearFr: 'free-coffee-year-fr.png',
  timcard50: 'timcard-50.png',
  timcard50Fr: 'timcard-50-fr.png',
  nhlSubscription: 'nhl-subscription.png',
  nhlSubscriptionFr: 'nhl-subscription.png',
  stanleyCupFinal: 'stanley-cup-final.png',
  stanleyCupFinalFr: 'stanley-cup-final.png',
  meetSydney: 'meet-sydney.png',
  meetSydneyFr: 'meet-sydney.png',

  // Game Info - Challenges
  challengeCardHeader: 'challenge-card-header.png',
  challengeCardBackground: 'challenge-card-header-background.png',

  // LeaderBoard Images
  playoffLogo: '2024_Stanley_Cup.png',
  playoffLogoEn: '2024_Stanley_Cup_Playoff_Logo_en.png',
  playoffLogoFr: '2024_Stanley_Cup_Playoff_Logo_fr.png',
  leaderboardResultsDivider: 'leaderboard-results-divider.png',
  seasonEnd: 'TH_TimBits_Trophy.png',
  challengeEnd: 'TH_TimBits_Foam_Hand.png',
  // History
  historyUnscored: 'static-loading-icon.svg',
  // PlayNow Images
  heatStreakBannerImg1Src: 'playoff_streak_large.png',
  heatStreakBannerImg2Src: 'playoff_streak_small.png',
  // Heatstreak Banner
  miniBannerBackground: 'heat_streak_playoff_background.png',
  heatstreakBannerBackground: '2025_streak_banner_bg.png',
};

const imageList = (version) =>
  Object.keys(allImages).reduce((acc, id) => {
    const image = allImages[id];
    return {
      ...acc,
      [id]: `${image}?v=${version}`,
    };
  }, {});

export { imageList };
